import React, { useState, useEffect } from 'react'
import ResizeObserver from 'resize-observer-polyfill'

const useElSize = (ref) => {
    const [width, setWidth] = useState(0)
    const [height, setHeight] = useState(0)
    const [top, setTop] = useState(0)
    const [left, setLeft] = useState(0)

    var ro = new ResizeObserver((entries) => {
        for (let entry of entries) {
            const cr = entry.contentRect

            if (cr.width !== width) {
                setWidth(cr.width)
            }
            if (cr.height !== height) {
                setHeight(cr.height)
            }
            if (cr.top !== top) {
                setTop(cr.top)
            }
            if (cr.left !== left) {
                setLeft(cr.left)
            }
        }
    })

    useEffect(() => {
        if (ref.current) {
            ro.observe(ref.current)
        }
    }, [ref.current])

    return {
        width,
        height,
        top,
        left,
    }
}

export default useElSize
